import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const LaundryOptionsContainer = styled.div`
    flex: 1;
    height: 60%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    padding: 2rem;
`;

export const TotalValue = styled.div`
    color: ${Colors.primary[100]};
    height: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    
    p {
        margin: 0;
        font-size: 4rem;
        font-weight: 500;
    }
`;
